import type { WithSlots } from "types";
import Card, { type CardProps } from "@mui/material/Card";
import CardHeader, { type CardHeaderProps } from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

type Props = WithSlots<
    CardProps,
    {
        header: CardHeaderProps;
    }
>;

const PreApplicationCard = ({ sx, children, slotProps }: Props) => (
    <Card
        sx={{
            width: 'clamp(300px, 100%, 600px)',
            ...sx
        }}
    >
        <CardHeader
            {...slotProps?.header}
            sx={{
                textAlign: 'center',
                ...slotProps?.header?.sx
            }}
        />
        <CardContent>
            {children}
        </CardContent>
    </Card>
);

export default PreApplicationCard;
